import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import Catalog from "./components/Catalog";
import Featured from "./components/Featured";
import People from "./components/People";
import CtaBand from "./components/CtaBand";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotList />
        <Catalog />
        <Featured />
        <People />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}